import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad,
  Route,
  Router,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import { PermissionAccessService } from 'src/app/services/authorization/permission-access.service';

@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanLoad, CanActivate {
  constructor(
    private readonly permissionAccess: PermissionAccessService,
    private readonly router: Router
  ) {}

  async canLoad(route: Route, _segments: UrlSegment[]): Promise<boolean | UrlTree> {
    return this.checkPermissions(route.data);
  }

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    return this.checkPermissions(route.data);
  }

  private async checkPermissions(data: { [key: string]: any } | undefined): Promise<boolean | UrlTree> {
    const permissions = (data?.['permissions'] ?? []) as string[];
    if (!permissions.length) {
      return true;
    }

    const isAllowed = await this.permissionAccess.hasAnyPermission(...permissions);
    return isAllowed ? true : this.router.parseUrl('/welcome');
  }
}
